import React from 'react';
import styled from 'styled-components';
import Up from '../../assets/up.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import Temperaturerise from '../../components/Temperaturerise/Temperaturerise';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardTemperaturerise extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Temperaturerise/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Up}
   metricsm="1.8°F average"
   diagnosis="Annual average temperature over the contiguous United States has increased by 1.2°F (0.7°C) over the last few decades and by 1.8°F (1.0°C) relative to the beginning of the last century."
   prediction="Annual average temperature in the contiguous United States is expected to increase by an additional 2.5°F (1.4°C) over the next few decades regardless of future greenhouse gas emissions (National Climate Assessment 2018)."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardTemperaturerise;
